import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "userPermissionDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "User Permission Detail", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "bg-light p-3 border rounded mb-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "Enter Name" }, "Enter Name", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "Enter Name" }, "Enter Email Address", -1)
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = {
  key: 0,
  class: "form-group"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { for: "Enter Name" }, "Select role", -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "row align-items-end" }
const _hoisted_22 = {
  key: 0,
  class: "col-md-8"
}
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { for: "Enter Name" }, "Amount Type", -1)
const _hoisted_25 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_28 = {
  class: "form-check-label",
  for: "defaultCheck1"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "bg-light p-3 border rounded mb-3" }
const _hoisted_32 = { class: "form-group mb-0" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { for: "" }, "Name of task", -1)
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "bg-light p-3 border rounded mb-3" }
const _hoisted_36 = { class: "form-group mb-0" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { for: "" }, "Task Description", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-dismiss": "modal"
  }, "Close")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      disabled: _ctx.state.data.userInput,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.userDetails.full_name = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.state.data.userDetails.full_name]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      disabled: _ctx.state.data.userInput,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.userDetails.email = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.state.data.userDetails.email]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_17, [
                  (_ctx.state.data.userDetails && _ctx.state.data.userDetails.invitation && _ctx.state.data.userDetails.invitation.role_id)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _withDirectives(_createVNode("select", {
                          name: "",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.userDetails.invitation.role_id = $event)),
                          disabled: _ctx.state.data.userInput
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.roles, (role, roleIndex) => {
                            return (_openBlock(), _createBlock("option", {
                              value: role.id,
                              key: roleIndex
                            }, _toDisplayString(role.name), 9, ["value"]))
                          }), 128))
                        ], 8, ["disabled"]), [
                          [_vModelSelect, _ctx.state.data.userDetails.invitation.role_id]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    (_ctx.state.data.userDetails && _ctx.state.data.userDetails.invitation && _ctx.state.data.userDetails.invitation.amount_type_id)
                      ? (_openBlock(), _createBlock("div", _hoisted_22, [
                          _createVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _withDirectives(_createVNode("select", {
                              name: "",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.userDetails.invitation.amount_type_id = $event)),
                              disabled: _ctx.state.data.userInput
                            }, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.amountTypes, (role, roleIndex) => {
                                return (_openBlock(), _createBlock("option", {
                                  value: role.id,
                                  key: roleIndex
                                }, _toDisplayString(role.name), 9, ["value"]))
                              }), 128))
                            ], 8, ["disabled"]), [
                              [_vModelSelect, _ctx.state.data.userDetails.invitation.amount_type_id]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.state.data.userDetails && _ctx.state.data.userDetails.invitation && _ctx.state.data.userDetails.invitation.amount)
                      ? (_openBlock(), _createBlock("div", _hoisted_25, [
                          _createVNode("div", _hoisted_26, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              disabled: _ctx.state.data.userInput,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.userDetails.invitation.amount = $event))
                            }, null, 8, ["disabled"]), [
                              [_vModelText, _ctx.state.data.userDetails.invitation.amount]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.state.data.userDetails && _ctx.state.data.userDetails.invitation && _ctx.state.data.userDetails.invitation.phaseUserPermissions && _ctx.state.data.userDetails.invitation.phaseUserPermissions.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_27, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.userDetails.invitation.phaseUserPermissions, (permission, permissionIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "form-check",
                          key: permissionIndex
                        }, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.isChecked = $event)),
                            id: "defaultCheck",
                            disabled: ""
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.state.data.isChecked]
                          ]),
                          _createVNode("label", _hoisted_28, _toDisplayString(permission.name), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      disabled: _ctx.state.data.taskDetails,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.taskDetails.name = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.state.data.taskDetails.name]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      disabled: _ctx.state.data.taskDetails,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.taskDetails.description = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.state.data.taskDetails.description]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_38
        ])
      ])
    ])
  ]))
}